module.exports = __webpack_public_path__ + "img/prestercito_landing-01.81e4ca70.gif";